import { translateOrderTypeItemName } from "../../../common/enums/orderTypes.enum";
export const newOrdersColumns = (t: any) => [
  {
    key: "Number",
    name: t('orders.columns.orderNumber'),
    fieldName: "number",
    minWidth: 100,
    maxWidth: 150,
    isResizable: true,
  },
  {
    key: "CreatedAt",
    name: t('orders.columns.orderDate'),
    fieldName: "createdAt",
    minWidth: 100,
    maxWidth: 120,
    isResizable: true,
  },
  {
    key: "Company",
    name: t('orders.columns.client'),
    fieldName: "company",
    minWidth: 400,
    maxWidth: 450,
    isResizable: true,
  },
  {
    key: "ReceptionPlace",
    name: t('orders.columns.receptionPlace'),
    fieldName: "receptionPlace",
    minWidth: 100,
    maxWidth: 350,
    isResizable: true,
  },
  {
    key: "Type",
    name: t('orders.columns.type'),
    fieldName: "type",
    minWidth: 50,
    maxWidth: 100,
    isResizable: true,
    onRender: (item: any) => {
      const map: any = { "Pojazd": t('orders.typeValues.vehicle'), "Kontener": t('orders.typeValues.container'), "Tonaż": t('orders.typeValues.tonnage'), "Specjalne": t('orders.typeValues.special') };
      return map[item.type] !== undefined ? map[item.type] : item.type;
    },
  },
  {
    key: "ContactPhone",
    name: t('orders.columns.phone'),
    fieldName: "contactPhone",
    minWidth: 50,
    maxWidth: 100,
    isResizable: true,
  },
  {
    key: "OrderTypeItem",
    name: t('orders.columns.vehicleType'),
    fieldName: "orderTypeItem",
    minWidth: 80,
    maxWidth: 120,
    isResizable: true,
    onRender: (item: any) => translateOrderTypeItemName(item.orderTypeItem, t),
  },
];